import Fetcher from '../../../../../services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from '../../../../../constants'
import {
  HealthSystemDetailsData,
  TGpoDetailsData,
  TGpoRelationUpdateRequest
} from './types'

const fetcher = new Fetcher({})

export const getHealthSystemDetails = async (uuid: string) =>
  fetcher.request<unknown, HealthSystemDetailsData>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.HEALTH_SYSTEMS}${uuid}/`,
    method: HTTP_METHODS.GET
  })
export const getGpoDetails = async (uuid: string) =>
  fetcher.request<unknown, TGpoDetailsData>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.HEALTH_SYSTEMS}${uuid}/${API_DICTIONARY.GPO_RELATION}`,
    method: HTTP_METHODS.GET
  })

export const updateGpoRelation = async (
  uuid: string,
  data: TGpoRelationUpdateRequest
) =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.HEALTH_SYSTEMS}${uuid}/${API_DICTIONARY.GPO_RELATION}`,
    method: HTTP_METHODS.PATCH,
    data
  })

export const updateGpoRelationName = async (
  uuid: string,
  data: TGpoRelationUpdateRequest
) =>
  fetcher.request<unknown, TGpoDetailsData>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.HEALTH_SYSTEMS}${uuid}/${API_DICTIONARY.GPO_RELATION}`,
    method: HTTP_METHODS.PUT,
    data
  })
